import { Stack, Container } from "@mantine/core";
import Stepper from "./Stepper";
import TripTypeSelector from "./TripTypeSelector";

export default function LandingLayout({ step, onNext, tripType, setTripType }) {
  return (
    <Container size={800}>
      <Stepper step={step} marginTop={30} />
      <Stack align="center" spacing="xl">
        <TripTypeSelector
          onNext={onNext}
          tripType={tripType}
          setTripType={setTripType}
        />
      </Stack>
    </Container>
  );
}
